import { Button } from "antd";
import { Link } from "react-router-dom";

const BillingHomeWebsite = () => {
  return (
    <>
      <Link to="/login">
        <Button type="primary">Sign In</Button>
      </Link>
      <Link to="/billing/signup">
        <Button type="primary">Sign Up</Button>
      </Link>
    </>
  );
};

export default BillingHomeWebsite;
